import React from 'react';
import AnimatedPage from '../components/AnimatedPage';

const Contact = () => {
  return (
    <AnimatedPage>
      <h1>Contact Page</h1>
      {/* Aquí va el contenido de contacto */}
    </AnimatedPage>
  );
};

export default Contact;
